const options = {
  5: "bg-amber-200/5",
  10: "bg-amber-200/10",
  25: "bg-amber-200/25",
  50: "bg-amber-200/50",
  75: "bg-amber-200/75",
  90: "bg-amber-200/90",
  100: "bg-amber-200",
};

const from = {
  5: "from-amber-200/5",
  10: "from-amber-200/10",
  25: "from-amber-200/25",
  50: "from-amber-200/50",
  75: "from-amber-200/75",
  90: "from-amber-200/90",
  100: "from-amber-200",
};

export default function getBackgroundAmber200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
